'use strict';

import React, { PropTypes } from 'react';
import moment from 'moment';
import 'moment-timezone';
// import _ from 'lodash/fp';

require('styles/Clock.css');
const clockFace = require('../images/clockface.png');

class ClockComponent extends React.Component {
  constructor() {
    super();

    this.state = {
      hour: 12,
      minute: 0
    };
  }

  static propTypes = {
    timeZone: PropTypes.string,
    label: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired
  }

  static defaultProps = {
    timeZone: 'Asia/Gaza',
    className: 'clock-component'
  }

  setTime() {
    const time = moment.tz(this.props.timeZone);
    this.setState({
      hour: time.hours(),
      minute: time.minutes()
    });
  }

  componentWillMount() {
    this.setTime();
    setInterval(this.setTime.bind(this), 60 * 1000);
  }

  transformFor(value, max) {
    const angle = Math.floor((value / max) * 360);
    return `rotate(${angle} 50 50)`;
  }

  render() {
    const minutesTransform = this.transformFor(this.state.minute, 60);
    const hourValue = (this.state.hour % 12) + (this.state.minute / 60);
    const hoursTransform = this.transformFor(hourValue, 12);
    return (
      <svg className={this.props.className}
           viewBox="0 0 100 120">
        <image xlinkHref={clockFace} width={100} height={100} x={0} y={0} />
        <circle cx={50} cy={50} r={3} style={{fillColor: 'black'}} />
        <line x1={50} y1={50} x2={50} y2={15} stroke="rgb(221, 221, 221)" strokeWidth={2}
              transform={minutesTransform} />
        <line x1={50} y1={50} x2={50} y2={30} stroke="rgb(221, 221, 221)" strokeWidth={2}
              transform={hoursTransform} />
        <text x={50} y={115} textAnchor="middle" fill="#d3d3d3">{this.props.label}</text>
      </svg>
    );
  }
}

ClockComponent.displayName = 'ClockComponent';

export default ClockComponent;



// WEBPACK FOOTER //
// ./src/components/ClockComponent.js